import { motion } from "framer-motion";
import { Reveal, MaskLineInView } from "./Reveal";

const chapters = [
  {
    num: "7",
    title: "Completion & Spiritual Formation",
    meaning: "Divine perfection and rest — the seven-step discipleship journey from encountering Jesus to serving and reproducing.",
    verse: "God rested on the seventh day. — Genesis 2:2",
    color: "#00E5FF",
  },
  {
    num: "9",
    title: "The Fruit of the Spirit",
    meaning: "Nine fruits — love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance — become our membership culture.",
    verse: "The fruit of the Spirit is... — Galatians 5:22–23",
    color: "#D4AF37",
  },
  {
    num: "11",
    title: "Vision, Discernment & Watchfulness",
    meaning: "A charged, high-frequency call to prayerful perception and biblical discernment in an age of deception — never date-setting, always watchful.",
    verse: "Watch therefore, for ye know neither the day nor the hour. — Matthew 25:13",
    color: "#9D4EDD",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 md:py-40 bg-[#0A0710]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-16 md:mb-24">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/2hy1xfs9_FOLWAC%20BANNER.png"
            alt="F.O.L.W.A.C. — Fountain of Living Water Apostolic Church. Jesus Christ makes all things new. Redeem, Restore, Revive, Rebuild."
            className="w-full rounded-3xl border border-white/10 shadow-[0_0_60px_rgba(106,13,173,0.35)]"
            data-testid="manifesto-banner-image"
          />
        </Reveal>
        <div className="max-w-3xl">
          <Reveal><span className="section-label">03 — The Manifesto</span></Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] mt-5 text-white">
            <MaskLineInView>Spiritually profound.</MaskLineInView>
            <MaskLineInView delay={0.1}><span className="italic text-gold">Biblically anchored.</span></MaskLineInView>
          </h2>
          <Reveal delay={0.2}>
            <p className="text-lg text-[#B4ADC1] font-light mt-6 leading-relaxed">
              The numbers 7, 9 and 11 are not superstition — they are teaching and campaign architecture, always governed by Scripture, never used to predict dates or manufacture fear.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 space-y-px">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="group relative grid md:grid-cols-12 gap-6 items-center py-12 border-t border-white/8"
              data-testid={`manifesto-${c.num}`}
            >
              <div className="md:col-span-4 relative">
                <span
                  className="font-display text-[10rem] md:text-[13rem] leading-none font-light block transition-transform duration-700 group-hover:scale-105"
                  style={{ color: c.color, opacity: 0.9, textShadow: `0 0 60px ${c.color}44` }}
                >
                  {c.num}
                </span>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-display text-3xl text-white leading-tight">{c.title}</h3>
                <p className="text-base text-[#B4ADC1] font-light mt-4 leading-relaxed">{c.meaning}</p>
              </div>
              <div className="md:col-span-3">
                <p className="font-display italic text-lg leading-snug" style={{ color: c.color }}>{c.verse}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* The Legendary Vision */}
        <Reveal delay={0.1}>
          <div className="mt-24 glass-gold rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-40 blur-3xl" style={{ background: "radial-gradient(circle at 50% 0%, rgba(212,175,55,0.25), transparent 60%)" }} />
            <p className="relative section-label justify-center">The Master Declaration</p>
            <p className="relative font-display text-3xl md:text-5xl font-light leading-[1.15] text-white mt-6 max-w-4xl mx-auto">
              "We carry the Living Water until <span className="italic text-gold">every reachable soul</span> has received a clear invitation to receive our Lord and Savior Jesus Christ."
            </p>
            <p className="relative font-mono text-xs tracking-[0.3em] uppercase text-[#7A708A] mt-8">Redeem · Restore · Revive · Rebuild</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
